/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface GetPaymentRequestDetail200ResponseEvidencesInnerErrors
 */
export interface GetPaymentRequestDetail200ResponseEvidencesInnerErrors {
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInnerErrors
     */
    'detectedDpi'?: GetPaymentRequestDetail200ResponseEvidencesInnerErrorsDetectedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInnerErrors
     */
    'calculatedDpi'?: GetPaymentRequestDetail200ResponseEvidencesInnerErrorsCalculatedDpiEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInnerErrors
     */
    'colorGradation'?: GetPaymentRequestDetail200ResponseEvidencesInnerErrorsColorGradationEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInnerErrors
     */
    'heightMillis'?: GetPaymentRequestDetail200ResponseEvidencesInnerErrorsHeightMillisEnum;
    /**
     * 
     * @type {string}
     * @memberof GetPaymentRequestDetail200ResponseEvidencesInnerErrors
     */
    'widthMillis'?: GetPaymentRequestDetail200ResponseEvidencesInnerErrorsWidthMillisEnum;
}

export const GetPaymentRequestDetail200ResponseEvidencesInnerErrorsDetectedDpiEnum = {
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestDetail200ResponseEvidencesInnerErrorsDetectedDpiEnum = typeof GetPaymentRequestDetail200ResponseEvidencesInnerErrorsDetectedDpiEnum[keyof typeof GetPaymentRequestDetail200ResponseEvidencesInnerErrorsDetectedDpiEnum];
export const GetPaymentRequestDetail200ResponseEvidencesInnerErrorsCalculatedDpiEnum = {
    pixelsInsufficient: 'PIXELS_INSUFFICIENT',
    pixelsRequired: 'PIXELS_REQUIRED',
    realSizeRequired: 'REAL_SIZE_REQUIRED',
    insufficient: 'INSUFFICIENT',
    unknown: 'UNKNOWN'
} as const;

export type GetPaymentRequestDetail200ResponseEvidencesInnerErrorsCalculatedDpiEnum = typeof GetPaymentRequestDetail200ResponseEvidencesInnerErrorsCalculatedDpiEnum[keyof typeof GetPaymentRequestDetail200ResponseEvidencesInnerErrorsCalculatedDpiEnum];
export const GetPaymentRequestDetail200ResponseEvidencesInnerErrorsColorGradationEnum = {
    required: 'REQUIRED',
    insufficient: 'INSUFFICIENT'
} as const;

export type GetPaymentRequestDetail200ResponseEvidencesInnerErrorsColorGradationEnum = typeof GetPaymentRequestDetail200ResponseEvidencesInnerErrorsColorGradationEnum[keyof typeof GetPaymentRequestDetail200ResponseEvidencesInnerErrorsColorGradationEnum];
export const GetPaymentRequestDetail200ResponseEvidencesInnerErrorsHeightMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetPaymentRequestDetail200ResponseEvidencesInnerErrorsHeightMillisEnum = typeof GetPaymentRequestDetail200ResponseEvidencesInnerErrorsHeightMillisEnum[keyof typeof GetPaymentRequestDetail200ResponseEvidencesInnerErrorsHeightMillisEnum];
export const GetPaymentRequestDetail200ResponseEvidencesInnerErrorsWidthMillisEnum = {
    required: 'REQUIRED'
} as const;

export type GetPaymentRequestDetail200ResponseEvidencesInnerErrorsWidthMillisEnum = typeof GetPaymentRequestDetail200ResponseEvidencesInnerErrorsWidthMillisEnum[keyof typeof GetPaymentRequestDetail200ResponseEvidencesInnerErrorsWidthMillisEnum];


